define.alias("shared/components/shared/addon-details-card/upcoming-plan", "media/components/shared/addon-details-card/upcoming-plan");